jQuery(document).ready(function($) {
    const debug = false;

    const teacherApplicationWrapper = $('.teacher-application-wrapper');
    if (teacherApplicationWrapper.length === 0) return;

    const allFetchedAppointments = [];

    const filtersForm = teacherApplicationWrapper.find('.application-filters-form');
    const dataContainer = teacherApplicationWrapper.find('.data-container');
    const appointmentsForm = teacherApplicationWrapper.find('.appointments-wrapper');
    const confirmationForm = teacherApplicationWrapper.find('.confirmation-wrapper');
    const summaryWrapper = teacherApplicationWrapper.find('.application-summary-wrapper');
    const sortBySelect = teacherApplicationWrapper.find('select#order');

    const courseNextButton = teacherApplicationWrapper.find('.course-next-button');
    const confirmButton = teacherApplicationWrapper.find('.confirmation-button');
    const confirmationCheckbox = teacherApplicationWrapper.find('input#confirmation');
    const confirmationTable = teacherApplicationWrapper.find('.confirmation-table');
    const notesButton = teacherApplicationWrapper.find('.add-notes');
    const choiceCountWrapper = teacherApplicationWrapper.find('.choice-count-wrapper');

    teacherApplicationWrapper.find('.tags-wrapper').each(function() {
        init_tag_input($(this)[0]);
    });

    writeCount(0, teacherApplicationWrapper.find('.result-count-wrapper'));
    writeCount(0, teacherApplicationWrapper.find('.choice-count-wrapper'));

    // Reset the entire selection
    const resetChoices = (fully = false) => {
        // clear all rows in the confirmation table
        confirmationTable.find('tbody tr').remove();

        // clear all hidden inputs in the confirmation form
        confirmationForm.find(`input.selected-appointment`).remove();

        if (fully) {
            appointmentsForm.find('input[type="checkbox"]').prop('checked', false);

            writeCount(0, choiceCountWrapper);
            summaryWrapper.find('.options-lead').toggle(false);
            confirmationForm.find('input[type="checkbox"]').prop('checked', false);
            confirmButton.prop('disabled', true);
        }
    }

    // Update the selected count
    const updateChoiceCount = () => {
        const selectedCount = confirmationForm.find('input.selected-appointment').length;
        writeCount(selectedCount, choiceCountWrapper);


        const hasAtLeastOneSelected = confirmationForm.find('input.selected-appointment').length > 0;
        // disable next and confirm if nothing was selected
        courseNextButton.prop('disabled', !hasAtLeastOneSelected);
        confirmButton.prop('disabled', !hasAtLeastOneSelected || !confirmationCheckbox.prop('checked'));

        summaryWrapper.find('.options-lead').toggle(selectedCount > 0);
    }

    let request;
    const applyFilters = _.debounce(async () => {
        const filters = filtersForm.serializeJSON().filters;

        dataContainer.isLoading();

        const orderBy = sortBySelect.val();

        // cancel previous request
        if (request) request.abort();
        request = $.getJSON({
            url: '/calendar/apply-as-teacher/get-options',
            data: { filters, orderBy },
        });

        // data is array of { appointment: object, html: string }
        const data = await request;
        dataContainer.doneLoading();

        // Remember the fetched appointments
        data.forEach(row => {
            if (allFetchedAppointments.indexOf(row.appointment.id) === -1) {
                allFetchedAppointments.push(row.appointment);
            }
        });

        writeCount(data.length, teacherApplicationWrapper.find('.result-count-wrapper'));


        // first make sure there is only one label and checkbox in the appointments form
        appointmentsForm.find('.appointment-row').slice(1).remove();

        // Hide the first row, in case this result has 0 rows
        dataContainer.find('.appointment-row').hide();


        data.forEach((dataRow, index) => {
            let row = dataContainer.find(`.appointment-row:eq(${index})`);
            if (row.length === 0) {
                row = dataContainer.find('.appointment-row').first().clone();
                dataContainer.append(row);
            }
            row.show();
            const label = row.find('label');
            const input = row.find('input[type="checkbox"]');
            const currentlySelected = confirmationForm.find(`input.selected-appointment[value="${dataRow.appointment.id}"]`).length > 0;
            input.prop('checked', currentlySelected);
            label.html(dataRow.html);
            const id = `appointment-${dataRow.appointment.id}`;
            label.attr('for', id);
            input.attr('id', id);
            input.attr('value', dataRow.appointment.id);
        });

        dataContainer.find('input[name="appointments[]"]').unbind('change').bind('change', function() {
            const checked = $(this).prop('checked');
            const changedAppointmentId = $(this).val();

            // read the form and parse the appointments in the confirmation table
            const appointmentsFormData = appointmentsForm.serializeJSON();
            let appointments = appointmentsFormData.appointments ? appointmentsFormData.appointments : [];

            // combine the appointments with the already selected appointments in the confirmation table
            appointments = _.uniq(appointments.concat(confirmationForm.find('input.selected-appointment').map(function() {
                return $(this).val();
            }).get()));

            if (!checked) {
                appointments = appointments.filter(appointment => {
                    return appointment !== changedAppointmentId;
                });
            }


            // sort ids by start_datetime
            appointments = appointments.sort((a, b) => {
                const aObject = allFetchedAppointments.find(row => row.id === parseInt(a));
                const bObject = allFetchedAppointments.find(row => row.id === parseInt(b));
                return aObject.start_datetime.localeCompare(bObject.start_datetime);
            });


            resetChoices();

            appointments.forEach(appointment => {
                const appointmentObject = allFetchedAppointments.find(row => row.id === parseInt(appointment));
                if (!appointmentObject) {
                    console.error('Appointment not found', {appointment, appointments, appointmentsFormData});
                    return;
                }

                const tr = $('<tr>');
                // make columns for start_datetime, end_datetime, description and address_name + city (combined with <br />)
                tr.append($('<td>').text(readable_date(appointmentObject.start_datetime, 'DD-MM-YYYY HH:mm')));
                tr.append($('<td>').text(readable_date(appointmentObject.end_datetime, 'HH:mm')));
                tr.append($('<td>').text(appointmentObject.description));
                tr.append($('<td>').html(`${appointmentObject.address_name}<br />${appointmentObject.city}`));
                tr.append($('<td>').html(`<a href="#" class="remove-choice"><span class="visual-icon-cross"></span>`));

                confirmationTable.find('tbody').append(tr);

                // Add a hidden input to the form
                confirmationForm.append($(`<input type="${debug ? 'text' : 'hidden'}" name="appointments[]" value="${appointmentObject.id}" class="selected-appointment" />`));

                // Remove the appointment from the list of choices when the remove button is clicked
                tr.find('.remove-choice').click(function(e) {
                    e.preventDefault();
                    const appointmentId = appointmentObject.id;
                    dataContainer.find(`input[name="appointments[]"][value="${appointmentId}"]`).prop('checked', false);

                    tr.remove();
                    confirmationForm.find(`input.selected-appointment[value="${appointmentId}"]`).remove();

                    updateChoiceCount();
                });
            });



            updateChoiceCount();
        });

    }, 250);

    filtersForm.find(':input[name], .tags-wrapper').bind('change changeTags', function() {
        applyFilters();
    });

    const reload = () => {
        filtersForm.find(':input[name]:first').trigger('change');
    }

    // Sort by select
    sortBySelect.change(function() {
        reload();
    });

    // Add or edit notes the application
    notesButton.addNotes();

    // Confirmation checkbox
    confirmationCheckbox.change(function() {
        const hasSelectedData = confirmationForm.find('input.selected-appointment').length > 0;
        confirmButton.prop('disabled', !$(this).prop('checked') || !hasSelectedData);
    });

    confirmationForm.submit(async function(e) {
        e.preventDefault();
        const values = $(this).serializeJSON();

        teacherApplicationWrapper.isLoading();
        await $.ajax({
            url: '/calendar/apply-as-teacher/apply',
            method: 'POST',
            data: values,
        });

        teacherApplicationWrapper.doneLoading();

        resetChoices(true);

        squde_reload_for_flashes();

        reload();
    });
});
